import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Watch the HARP Manual Proofing video for more info',
      link: 'https://www.youtube.com/watch?v=rYioFNNvtD0&t=28s',
    },
  ],
  contactDetails: {
    hours: '7:00 AM - 7:00 PM CT',
    days: 'Monday - Friday',
    email: 'Identity.proofing@cms.hhs.gov',
    phone1: '1-866-288-8914',
  },
} as ContactConfig;
